import L from 'leaflet';

export const offsetMarkerPosition = (latitude, longitude, index, total) => {
  const offset = 0.0002;
  const angle = (index / total) * 2 * Math.PI;
  const newLat = latitude + offset * Math.cos(angle);
  const newLon = longitude + offset * Math.sin(angle);
  return [newLat, newLon];
};

const typeColors = {
  'Neuf': '#4CAF50',
  'Rénovation': '#2196F3',
  'Extension': '#FF9800',
  'Réhabilitation': '#9C27B0',
  'Réaffectation / Réutilisation': '#795548',
  'Restauration': '#E91E63',
  'Démolition / Reconstruction': '#F44336'
};

const programEmojis = {
  'Agriculture et Environnement': '🌾',
  'Commerce': '🏪',
  'Culturel': '🎭',
  'Educatif': '📚',
  'Gouvernemental': '🏛️',
  'Historique': '🏺',
  'Hôtellerie et Restauration': '🏨',
  'Industriel': '🏭',
  'Infrastructure': '⚡',
  'Justice et Sécurité': '⚖️',
  'Loisirs et Divertissements': '🎮',
  'Urbanisme et Espaces Publics': '🌳',
  'Résidentiel': '🏠',
  'Religieux': '⛪',
  'Santé': '🏥',
  'Science et Technologie': '🔬',
  'Sportif': '⚽',
  'Services et Bureaux': '💼',
  'Transport': '🚉'
};

export const getMarkerIcon = (project) => {
  // Gestion des différentes structures possibles pour les types
  let type = null;
  if (project.types && Array.isArray(project.types) && project.types.length > 0) {
    type = project.types[0];
  } else if (project.type) {
    type = project.type;
  }

  // Gestion des différentes structures possibles pour les programmes
  let program = null;
  if (project.programmes && Array.isArray(project.programmes) && project.programmes.length > 0) {
    program = project.programmes[0];
  } else if (project.programme) {
    program = project.programme;
  }
  
  const color = typeColors[type] || '#808080';
  const emoji = program ? programEmojis[program] : '📍';
  
  // Créer un élément div pour le marqueur personnalisé
  const markerHtml = `
    <div class="custom-marker-container">
      <div class="custom-marker">
        <div class="marker-pin" style="background-color: ${color}"></div>
        <div class="marker-emoji">${emoji}</div>
      </div>
    </div>
  `;

  const style = document.createElement('style');
  style.textContent = `
    .custom-marker-container {
      position: relative;
      width: 36px;
      height: 50px;
    }
    .custom-marker {
      position: absolute;
      width: 100%;
      height: 100%;
    }
    .marker-pin {
      width: 36px;
      height: 36px;
      border-radius: 50% 50% 50% 0;
      position: absolute;
      transform: rotate(-45deg);
      left: 50%;
      top: 50%;
      margin: -18px 0 0 -18px;
      border: 2px solid #FFFFFF;
      box-shadow: 0 2px 4px rgba(0,0,0,0.3);
      transition: all 0.3s ease;
    }
    .marker-emoji {
      position: absolute;
      left: 20px;
      top: 26px;
      transform: translate(-50%, -50%);
      width: 22px;
      height: 22px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 18px;
      pointer-events: none;
    }
    .custom-marker:hover .marker-pin {
      transform: rotate(-45deg) scale(1.1);
      box-shadow: 0 3px 6px rgba(0,0,0,0.4);
    }
  `;
  document.head.appendChild(style);

  return L.divIcon({
    html: markerHtml,
    className: 'custom-marker-icon',
    iconSize: [36, 50],
    iconAnchor: [18, 50],
    popupAnchor: [0, -50]
  });
};
